@let isAward = (isNotAward$ | async) === false;
@if (fareFamily$ | async; as fareFamily) {
  <div
    [attr.data-testid]="'fare-family-card-' + fareFamily.selected"
    class="fare-family border rounded-large overflow-hidden white-bg surface-primary"
    [class.selected]="fareFamily.selected"
    [class.disabled]="fareFamily.disabled"
    [ngStyle]="{
      outlineColor: fareFamily.selected
        ? isNewBrand()
          ? 'var(--border-accent)'
          : fareFamily.benefits.brandColor
        : null,
    }"
  >
    @for (tag of fareFamily.benefits?.tags ?? []; track tag.text) {
      <div class="absolute badge z1 ms-xsmall-t ms-xsmall-r" [attr.data-testid]="'benefit-tags-' + tag.text">
        <fcom-tag [theme]="tagTheme$ | async" [roundingStyle]="castTagRoundingStyle(tag.roundingStyle)">
          @if (tag.icon && (tag.iconPosition === 'left' || tag.iconPosition === undefined)) {
            <fcom-icon
              [name]="castIconName(tag.icon.name)"
              [category]="castIconCategory(tag.icon.category)"
              class="icon-small ms-xxsmall-r"
            />
          }
          <span>{{ tag.text }}</span>
          @if (tag.icon && tag.iconPosition === 'right') {
            <fcom-icon
              [name]="castIconName(tag.icon.name)"
              [category]="castIconCategory(tag.icon.category)"
              class="icon-small ms-xxsmall-r"
            />
          }
        </fcom-tag>
      </div>
    }
    <label
      class="flex flex--column nordic-blue-25-bg surface-secondary"
      [style.--brand-color]="fareFamily.benefits.brandColor"
      [attr.aria-label]="
        'ticketSelection.aria.fareFamily.fareFamilyOption'
          | finLocalization
            : {
                fareFamily: fareFamily.benefits.brandName,
                price:
                  {
                    amount: fareFamily.totalPrice,
                    currencyCode: currencyCode,
                  } | finPrice,
                index: aria.index + 1,
                totalCount: aria.count,
              }
      "
      [attr.data-testid]="'fare-family-label-' + fareFamily.fareFamilyCode"
    >
      <input
        [attr.data-testid]="'fare-family-checkbox-' + fareFamily.fareFamilyCode"
        (change)="checkboxChange($event)"
        type="checkbox"
        class="hidden-checkbox"
        [checked]="fareFamily.selected"
        [disabled]="fareFamily.disabled"
      />

      <div class="ps-small-x ps-small-b" aria-hidden="true">
        @if (fareFamily.badgeType === FareFamilyBadgeType.POPULAR) {
          <fcom-tag
            [theme]="fareFamily.selected ? TagTheme.DEFAULT : TagTheme.POPULAR"
            class="absolute popular-badge ms-xsmall-t ms-xsmall-r"
            [attr.data-testid]="'badge-tag'"
          >
            {{ 'ticketSelection.fareFamily.ribbonText' | finLocalization }}
          </fcom-tag>
        }

        <fcom-icon
          class="white-bg surface-primary circle checkbox-icon"
          [dataTestId]="'fare-family-icon-' + fareFamily.fareFamilyCode"
          [name]="
            fareFamily.selected ? SvgLibraryIcon.CHECKMARK_BUTTON_SELECTED : SvgLibraryIcon.CHECKMARK_BUTTON_UNSELECTED
          "
        />
        <div
          class="fare-family-name font-body-1 medium-type nordic-blue-900-text text-icon-primary ms-xsmall-t font-label-medium"
        >
          {{ fareFamily.benefits.brandName }}
        </div>
        <div
          class="fare-family-price font-heading-4 font-title-medium"
          [class.with-original-price]="fareFamily?.originalTotalPrice && fareFamily?.discountReasonCode"
          data-testid="fare-family-price-container"
        >
          <span class="total-price-text" data-testid="fare-family-price">
            @if (isAward) {
              {{ 'award.points' | finLocalization: { pointsAmount: fareFamily.points || 0 | finPoints } }}
              +
            }
            {{
              {
                amount: isShowTotalPrice ? fareFamily.totalPrice : fareFamily.price,
                currencyCode: currencyCode,
              } | finPrice
            }}
          </span>
          @if (fareFamily.discountReasonCode && (fareFamily.originalTotalPrice || fareFamily.originalPrice)) {
            <span
              class="strike-through regular-type font-body-2 font-body-small"
              data-testid="fare-family-strike-price"
            >
              {{
                {
                  amount: isShowTotalPrice ? fareFamily.originalTotalPrice : fareFamily.originalPrice,
                  currencyCode: currencyCode,
                } | finPrice
              }}
            </span>
          }
        </div>
      </div>
      <div
        class="fare-family-brand-color-bar ps-xxsmall"
        [style.background-color]="fareFamily.benefits.brandColor"
      ></div>
    </label>
    <div class="fare-family-benefits ps-xxsmall-x">
      @if (!isAward) {
        <fcom-tag [theme]="aviosTagTheme()" class="ms-small-l ms-small-t">
          <fcom-icon class="ms-xxsmall-r icon-small" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
          <span data-testid="fare-family-option-avios-accrual">
            @if (fareFamily.totalAviosAccrual) {
              {{ 'avios.collectPointsTag' | finLocalization: { points: (fareFamily.totalAviosAccrual | finPoints) } }}
            } @else {
              {{ 'avios.collectUndefinedPoints' | finLocalization }}
            }
          </span>
        </fcom-tag>
      }

      <div class="benefits-list flex-1 benefits ms-small-b">
        @for (benefit of fareFamilyBenefit$ | async; track benefit.key; let first = $first) {
          <fin-benefit
            class="block ps-small-x"
            [showKoreaNotification]="showKoreaNotification"
            [benefit]="benefit"
            [enableBenefitChanges$]="true | finToObservable"
            [ngClass]="{
              'ps-xsmall-t ps-xxsmall-b': first,
              'ps-xxsmall-y': !first,
            }"
          />
        }
      </div>
    </div>
  </div>
}
